var exports = {
  "s": "xfd349460--b2a9ad--player_icon",
};

module.exports = exports;
